



































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import { timeoutDefault } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { SolicitacaoAcoesBackofficeEnum } from '@/types/_'
import { Autorizacao } from '@/types/core'

@Component
export default class ComponentModalEnviarParaRetornoDeCotacaoBtn extends Vue {
  @Prop({ required: true, default: '' }) modalParent: string
  context: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  modal: boolean = false
  loadSave: boolean = false
  loadCloseToolbar: boolean = false
  loadCloseCancelar: boolean = false

  get loadingCloseCancelar() {
    return this.loadCloseCancelar
  }

  set loadingCloseCancelar(value: boolean) {
    this.loadCloseCancelar = value
  }

  get loadingCloseToolbar() {
    return this.loadCloseToolbar
  }

  set loadingCloseToolbar(value: boolean) {
    this.loadCloseToolbar = value
  }

  get loadingSave() {
    return this.loadSave
  }

  set loadingSave(value: boolean) {
    this.loadSave = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  async closeToolbar() {
    this.loadingCloseToolbar = true
    await timeoutDefault()
    this.modal = false
    this.loadingCloseToolbar = false
  }

  async closeCancelar() {
    this.loadingCloseCancelar = true
    await timeoutDefault()
    this.modal = false
    this.loadingCloseCancelar = false
  }

  async enviarParaRetornoDeCotacao() {
    this.loadingSave = true
    const { id } = this.getBackofficeGlobalStore.solicitacao

    const params = {
      acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoEnviaParaRetornoDeCotacao,
      body: { solicitacaoId: id },
    }

    const response = await this.context.enviarGuias(params)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitacao enviada para Retorno de Cotação com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na solicitação..', icon: 'warning', color: '#C62828' })
    }
    this.loadingSave = false
  }

  async closeModal() {
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.context.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getBackofficeGlobalStore.closeModalAutorizarProcesso()
    this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.modal = false
    this.getBackofficeGlobalStore.setModal({ name: this.modalParent, value: false })
  }
}
